import React from 'react';
import Utils from 'commons/utils';
import { SearchInputColumn, DatePickerSearchColumn } from 'components';
import { Button, Badge } from '@mui/material';

const renderUser = (arrayUsers) => {
  if (arrayUsers?.length < 1) return;
  let userFormat = arrayUsers?.map((item) => item?.name);
  return Utils.showArrayInTale(userFormat);
};

const renderService = (arrayServices) => {
  if (arrayServices?.length < 1) return;
  let serviceFormat = arrayServices?.map((item) => item?.name);
  return Utils.showArrayInTale(serviceFormat);
};

export const getColumns = (
  onChangeSearch,
  handleTakeCareAgain,
  handleChangeSupporter,
  searchSuspensionDate,
  handleChangeSearchSuspensionDate,
  searchFoundingDate,
  handleChangeSearchFoundingDate,
) => [
    {
      id: 'code',
      numeric: false,
      disablePadding: false,
      label: <SearchInputColumn title="Mã" name="objClientCompany.code" onChange={onChangeSearch} />,
      width: '10px',
      align: 'center',
      render: (row) => row?.objClientCompany?.code,
    },
    {
      id: 'name',
      numeric: true,
      disablePadding: false,
      align: 'center',
      width: '200px',
      label: (
        <SearchInputColumn
          title="Khách hàng"
          name="objClientCompany.name"
          onChange={onChangeSearch}
        />
      ),
      render: (row) => row?.objClientCompany?.name,
    },
    {
      id: 'arrService',
      numeric: true,
      disablePadding: false,
      label: <SearchInputColumn title="Dịch vụ" name="arrService.name" onChange={onChangeSearch} />,
      align: 'left',
      render: (row) => renderService(row?.arrService || []),
    },
    {
      id: 'tax_Code',
      numeric: true,
      disablePadding: false,
      label: <SearchInputColumn title="Mã số thuế" name="tax_Code" onChange={onChangeSearch} />,
      align: 'center',
      render: (row) => row?.objClientCompany?.tax_Code,
    },
    {
      id: 'arrAddress',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Địa chỉ"
          name="objClientCompany.arrAddress"
          onChange={onChangeSearch}
        />
      ),
      width: '250px',
      align: 'left',
      render: (row) => Utils.showArrayInTale(row?.objClientCompany?.arrAddress),
    },
    {
      id: 'representer',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Người đại diện"
          name="objClientCompany.representer"
          onChange={onChangeSearch}
        />
      ),
      align: 'center',
      render: (row) => row?.objClientCompany?.representer,
    },
    {
      id: 'phoneRepresenter',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="SĐT Người đại diện"
          name="objClientCompany.phoneRepresenter"
          onChange={onChangeSearch}
        />
      ),
      align: 'center',
      render: (row) => row?.objClientCompany?.phoneRepresenter,
    },
    {
      id: 'arrFax',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Ứng dụng liên hệ"
          name="objClientCompany.arrFax"
          onChange={onChangeSearch}
        />
      ),
      align: 'center',
      render: (row) => Utils.showArrayInTale(row?.objClientCompany?.arrFax),
    },
    {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn title="Loại CT" name="objClientCompany.email" onChange={onChangeSearch} />
      ),
      align: 'center',
      render: (row) => row?.objClientCompany?.email,
    },
    {
      id: 'foundingDate',
      numeric: true,
      disablePadding: false,
      label: (
        <div>
          <div>Ngày thành lập</div>
          <DatePickerSearchColumn
            sx={{
              marginBottom: '10px',
              padding: 0,
            }}
            width={'140px'}
            marginTop="0"
            size="small"
            onChange={handleChangeSearchFoundingDate}
            value={searchFoundingDate}
            error={true}
            label=""
          />
        </div>
      ),
      align: 'center',
      render: (row) =>
        row?.objClientCompany?.foundingDate
          ? Utils.formatDateFn(row?.objClientCompany?.foundingDate)
          : '',
    },
    {
      id: 'companyType',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Loại CT"
          name="objClientCompany.companyType"
          onChange={onChangeSearch}
        />
      ),
      align: 'center',
      render: (row) => <>{row?.objClientCompany?.companyType}</>,
    },
    {
      id: 'arrMainUserobj',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Sales"
          // title="Phụ trách chính"
          name="arrMainUserobj.name"
          onChange={onChangeSearch}
        />
      ),
      align: 'left',
      render: (row) => renderUser(row?.arrMainUserobj || []),
    },
    {
      id: 'arrSecondaryUserobj',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="CS"
          // title="Phụ trách phụ"
          name="arrSecondaryUserobj.name"
          onChange={onChangeSearch}
        />
      ),
      align: 'left',
      render: (row) => renderUser(row?.arrSecondaryUserobj || []),
    },
    {
      id: 'suspensionDate',
      numeric: true,
      disablePadding: false,
      // label: 'Ngày chuyển về từ sàn lọc Lead',
      label: (
        <div>
          <div>Ngày chuyển</div>
          <DatePickerSearchColumn
            sx={{
              marginBottom: '10px',
              padding: 0,
            }}
            width={'140px'}
            marginTop="0"
            size="small"
            onChange={handleChangeSearchSuspensionDate}
            value={searchSuspensionDate}
            error={true}
            label=""
          />
        </div>
      ),
      align: 'center',
      render: (row) =>
        row?.objClientCompanyPause?.suspensionDate
          ? Utils.formatDateFn(row?.objClientCompanyPause?.suspensionDate)
          : '',
    },
    {
      id: 'userSuspension',
      numeric: true,
      disablePadding: false,
      label: (
        <SearchInputColumn
          title="Người chuyển"
          name="objClientCompanyPause.userSuspension"
          onChange={onChangeSearch}
        />
      ),
      align: 'center',
      render: (row) =>
        row?.objClientCompanyPause?.userSuspension ? row?.objClientCompanyPause?.userSuspension : '',
    },
    {
      id: 'note',
      numeric: true,
      disablePadding: false,
      label: <SearchInputColumn title="Ghi chú" name="note" onChange={onChangeSearch} />,
      align: 'center',
    },
    {
      id: 'actions',
      numeric: true,
      disablePadding: false,
      label: 'Thao tác',
      width: '150px',
      fixed: 'right',
      render: (row) => (
        <>
          <Button
            variant="contained"
            size="small"
            color="primary"
            sx={{
              borderRadius: '15px',
              textTransform: 'none',
              m: '5px',
              fontWeight: 'normal',
              padding: '4px 15px',
            }}
            onClick={() => window.showConfirm(() => handleTakeCareAgain(row), 'Chăm sóc lại?')}
          >
            Chăm sóc lại
          </Button>
          <Badge badgeContent={row.reject || 0} color="primary">
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{
                borderRadius: '15px',
                textTransform: 'none',
                marginTop: '10px',
                fontWeight: 'normal',
                padding: '4px 15px',
              }}
              onClick={() => handleChangeSupporter(row)}
            >
              Đổi phụ trách
            </Button>
          </Badge>
        </>
      ),
    },
  ];
